import { render } from "./KostenTestphase.vue?vue&type=template&id=2269c796"
import script from "./KostenTestphase.vue?vue&type=script&lang=js"
export * from "./KostenTestphase.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__